


































































import { defineComponent, ref, computed } from '@vue/composition-api';
import { FCSelect } from '@fc/angie-ui';
import FCImage from '~/components/FCImage.vue';
import WrapGloveSize from './WrapGloveSize.vue';

export default defineComponent({
  name: 'GenericUpsell',
  components: {
    FCImage,
    FCSelect,
    WrapGloveSize,
  },
  props: {
    productId: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    errorMessage: {
      type: String,
      default: null,
    },
  },
  emits: ['selected'],
  setup(props, { emit }) {
    // @ts-ignore
    const { $store } = useNuxtApp();
    const product = computed(() => $store.getters.productsCollection?.find((item: any) => item.id === props.productId));
    const isChecked = ref(false);
    const selectedVariantId = ref<string | null>(null);
    const hasVariants = computed(() => (product.value?.variants?.length ?? 0) > 1);
    const variantOptions = computed(() => (product.value?.variants ?? []).map((variant: any) => ({ key: variant.id, name: variant.name })));

    function toggleCheck() {
      isChecked.value = !isChecked.value;
      if (!isChecked.value) {
        // If unchecked, emit removal for this product (with selected variant if present)
        emit('selected', {
          checked: false,
          product: {
            ...product.value,
            selectedVariantId: selectedVariantId.value,
          },
        });
        selectedVariantId.value = null;
        return;
      }

      if (!hasVariants.value) {
        emit('selected', {
          checked: isChecked.value,
          product: {
            ...product.value,
            selectedVariantId: product.value?.variants?.[0]?.id || null,
          },
        });
      } else {
        // If checked and has variants, emit with selectedVariantId (may be null)
        emit('selected', {
          checked: true,
          product: {
            ...product.value,
            selectedVariantId: selectedVariantId.value,
          },
        });
      }
    }

    function onVariantChange(val: string) {
      selectedVariantId.value = val;
      if (isChecked.value) {
        emit('selected', {
          checked: true,
          product: {
            ...product.value,
            selectedVariantId: val,
          },
        });
      }
    }

    const productPrice = computed(() => product.value?.variants?.[0]?.price ?? '');
    const productImage = computed(() => product.value?.images?.[1] || product.value?.images?.[0] || '');
    const hasError = computed(() => !!props.errorMessage && isChecked.value);
    const displayOldPrice = computed(() => product.value.variants[0].compareAtPrice > productPrice.value);

    return {
      isChecked,
      toggleCheck,
      product,
      hasVariants,
      variantOptions,
      selectedVariantId,
      onVariantChange,
      productPrice,
      productImage,
      hasError,
      displayOldPrice,
    };
  },
});
